import { useState, useEffect } from "react";

/**
 * Detects the visitor's country via the /api/geo backend endpoint.
 *
 * - Returns { country: null, loading: true } on the first render so callers
 *   can show a skeleton instead of the wrong country's content.
 * - Caches the result in sessionStorage so repeat visits are instant (no
 *   skeleton, no extra network request).
 * - Falls back to "IN" silently on any network / API error.
 */
export function useGeo() {
    const [country, setCountry] = useState(null); // null = not yet resolved

    useEffect(() => {
        const cached = sessionStorage.getItem("userCountry");
        if (cached) {
            setCountry(cached);
            return;
        }

        fetch("/api/geo")
            .then((res) => res.json())
            .then((data) => {
                const c = data.country || "IN";
                setCountry(c);
                sessionStorage.setItem("userCountry", c);
            })
            .catch(() => setCountry("IN"));
    }, []);

    return { country, loading: country === null };
}
